import smData from './smData'
import userDetails from './userDetails'


export { 
    smData,
    userDetails
}